/**
 * Javascript for local storage of ige_shop.
 * Product Owner: Raphael Wälterlin <raphael.waelterlin@cabag.ch>
 * Author: Markus Gehrig <markus.gehrig@cabag.ch>
 * Date: 15. Apr 2019
 * 
 * Customer: Prospecia Rara
 * Company: cab services ag
 */

var $ = require('../../../../../../../webpack/node_modules/jquery');

function setItem(key, value) {
    sessionStorage.setItem(key, value);
}

function getItem(key) {
    return sessionStorage.getItem(key);
}


module.exports = {
    setItem,
    getItem
}
